import { PageLocaleEnum } from 'common/enums/PageLocaleEnum'
import styled, { css, RuleSet } from 'styled-components'
import { PriceElementBaseProps } from '../../price-element-interface'
import { getSliderContainerStyles } from '../../utils'

export const PriceElementPlansWrapperUi = styled.div`
  display: flex;
  width: 100%;

  @media only screen and (max-width: 1000px) {
    margin-top: 30px;
  }

  ${p =>
    p.theme.isEditorMobileMode &&
    css`
      margin-top: 30px;
    `}
`

export const PriceElementPlansPaginationUi = styled.div`
  display: none;
  ${p => p.theme.phone} {
    width: 50%;
    display: flex;
    align-items: flex-end;
  }

  ${p =>
    p.theme.isEditorMobileMode &&
    css`
      width: 50%;
      display: flex;
      align-items: flex-end;
    `}
`
export const PriceElementPlansPaginationButtonUi = styled.button`
  background-color: transparent;
  font-size: 30px;
  color: rgba(4, 164, 252, 1);
  cursor: pointer;
  transition: color 0.25s ease;
  border: none;

  &:disabled {
    color: #c5ccd9;
    cursor: default;
  }
`

interface PriceElementPlansUiStylesInterface extends PriceElementBaseProps {
  isDisabled: boolean
}

export const PriceElementPlansContainerUi = styled.div`
  width: 100%;
  overflow: hidden;
  align-self: flex-end;

  ${p => p.theme.phone} {
    width: 50%;
    ${getSliderContainerStyles()}
  }

  ${p =>
    p.theme.isEditorMobileMode &&
    css`
      width: 50%;      
    ` &&
    getSliderContainerStyles()}
`

export const PriceElementPlansUi = styled.div<PriceElementPlansUiStylesInterface>`
  display: flex;
  width: 100%;
  gap: 30px;

  @media only screen and (max-width: 1200px) {
    gap: 10px;
  }

  @media only screen and (max-width: 1000px) {
    gap: 30px;
  }

  ${p => p.theme.phone} {
    ${p =>
      !p.isDisabled &&
      css`
        will-change: transform;
        gap: 10%;
      `}
  }

  ${p =>
    p.theme.isEditorMobileMode &&
    (
      !p.isDisabled &&
        css`
          will-change: transform;
          gap: 10%;      
      `
    )}
`

export const PriceElementPlanUi = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  justify-content: flex-end;

  ${p => p.theme.phone} {
    flex: 0 0 100%;
  }

  ${p =>
    p.theme.isEditorMobileMode &&
    css`
      flex: 0 0 100%;
    `}
`

const getPriceElementPlanTitleStylesForLocale = (
  locale: PageLocaleEnum,
): RuleSet => {
  switch (locale) {
    case PageLocaleEnum.POLISH:
      return css`
        font-size: 22px;
        @media only screen and (max-width: 1200px) {
          font-size: 18px;
        }
        @media only screen and (max-width: 1000px) {
          font-size: 20px;
        }
      `
    case PageLocaleEnum.JAPANESE:
      return css`
        font-size: 22px;
        @media only screen and (max-width: 1200px) {
          font-size: 18px;
        }
        @media only screen and (max-width: 1000px) {
          font-size: 22px;
        }
      `

    default:
      return css`
        font-size: 22px;
      `
  }
}

export const PriceElementPlanTitleUi = styled.div<PriceElementBaseProps>`
  color: #142d63;
  font-weight: 500;
  line-height: 20px;
  width: 100%;
  text-align: center;

  ${p => p.locale && getPriceElementPlanTitleStylesForLocale(p.locale)}
`

export const PriceElementPlanPriceWrapperUi = styled.div`
  margin-bottom: 20px;
  margin-top: 15px;
  color: #142d63;
  line-height: 20px;
  font-size: 16px;
  font-weight: 400;

  ${p => p.theme.phone} {
    margin-bottom: 15px;
    margin-top: 10px;
  }

  ${p =>
    p.theme.isEditorMobileMode &&
    css`
      margin-bottom: 15px;
      margin-top: 10px;
    `}
`

const getPriceElementPlanPriceStylesForLocale = (
  locale: PageLocaleEnum,
): RuleSet => {
  switch (locale) {
    case PageLocaleEnum.HUNGARIAN:
      return css`
        font-size: 25px;

        @media only screen and (max-width: 1200px) {
          font-size: 17px;
        }

        @media only screen and (max-width: 1000px) {
          font-size: 22px;
        }
      `

    case PageLocaleEnum.ROMANIAN:
      return css`
        font-size: 28px;

        @media only screen and (max-width: 1200px) {
          font-size: 22px;
        }

        @media only screen and (max-width: 1000px) {
          font-size: 24px;
        }
      `

    case PageLocaleEnum.ALBANIA:
      return css`
        font-size: 26px;

        @media only screen and (max-width: 1200px) {
          font-size: 20px;
        }

        @media only screen and (max-width: 1000px) {
          font-size: 22px;
        }
      `

    case PageLocaleEnum.INDONESIAN:
      return css`
        font-size: 20px;
        @media only screen and (max-width: 1200px) {
          font-size: 13px;
        }
        @media only screen and (max-width: 1000px) {
          font-size: 15px;
        }
      `

    case PageLocaleEnum.SERBIAN:
      return css`
        font-size: 20px;
        @media only screen and (max-width: 1200px) {
          font-size: 13px;
        }
        @media only screen and (max-width: 1000px) {
          font-size: 18px;
        }
      `

    case PageLocaleEnum.UKRAINIAN:
      return css`
        font-size: 24px;
        @media only screen and (max-width: 1200px) {
          font-size: 16px;
        }
        @media only screen and (max-width: 1000px) {
          font-size: 20px;
        }
      `

    case PageLocaleEnum.POLISH:
      return css`
        font-size: 30px;
        @media only screen and (max-width: 1200px) {
          font-size: 24px;
        }
      `

    case PageLocaleEnum.JAPANESE:
      return css`
        font-size: 30px;
        @media only screen and (max-width: 1200px) {
          font-size: 22px;
        }
        @media only screen and (max-width: 1000px) {
          font-size: 24px;
        }
      `

    default:
      return css`
        font-size: 30px;

        @media only screen and (max-width: 1200px) {
          font-size: 24px;
        }
        ${p =>
          p.theme.isEditorMobileMode &&
          css`
            font-size: 24px;
          `}
      `
  }
}

export const PriceElementPlanPriceUi = styled.span<PriceElementBaseProps>`
  font-weight: 700;
  line-height: 20px;

  ${p => p.locale && getPriceElementPlanPriceStylesForLocale(p.locale)}

  ${p => p.theme.phone} {
    font-size: 24px;
  }

  ${p =>
    p.theme.isEditorMobileMode &&
    css`
      font-size: 24px;
    `}
`

interface PriceElementPlanButtonUiStylesInterface
  extends PriceElementBaseProps {
  isDisabled: boolean
}

const getPriceElementPlanButtonStylesForLocale = (
  locale: PageLocaleEnum,
): RuleSet => {
  switch (locale) {
    case PageLocaleEnum.RUSSIAN:
      return css`
        font-size: 16px;
      `
    case PageLocaleEnum.SPANISH:
      return css`
        font-size: 16px;
      `
    case PageLocaleEnum.CZECH:
      return css`
        font-size: 16px;
      `
    case PageLocaleEnum.POLISH:
      return css`
        @media only screen and (max-width: 1200px) {
          font-size: 13px;
        }
      `

    default:
      return css`
        font-size: 18px;
        line-height: 32px;
      `
  }
}

export const PriceElementPlanButtonUi = styled.button<PriceElementPlanButtonUiStylesInterface>`
  width: 100%;
  background-color: #00a0ff;
  background-color: ${p => (p.isDisabled ? '#e4e8f0' : '#00a0ff')};
  border-radius: 5px;
  color: white;
  text-align: center;
  font-weight: 500;
  line-height: 32px;
  text-transform: uppercase;
  padding: 6px 0;
  cursor: ${p => (p.isDisabled ? 'default' : 'pointer')};
  border: none;

  @media only screen and (max-width: 1200px) {
    font-size: 16px;
    line-height: 30px;
  }

  ${p => p.locale && getPriceElementPlanButtonStylesForLocale(p.locale)}

  ${p =>
    p.theme.isEditorMobileMode &&
    css`
      font-size: 16px;
      line-height: 30px;
    `}
`
